import { render, staticRenderFns } from "./approvalDetailDialog.vue?vue&type=template&id=f1dc64ac"
import script from "./approvalDetailDialog.vue?vue&type=script&lang=js"
export * from "./approvalDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./approvalDetailDialog.vue?vue&type=style&index=0&id=f1dc64ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports